export default "__VITE_ASSET__BBT8Aqrj__"